<template>
  <div class="airports">
    <toolbar
      backRoute="/dashboard"
      title="Airports"
      :addButton="true"
      addButtonLabel="Add airport"
      addButtonRoute="/dashboard/airports/new" />

    <d-row class="mt-5">
      <d-col cols="12" class="d-flex">
        <d-input
          v-model="filters.search"
          placeholder="Search airports"
          @keyup.native.enter="saveFilters" />
        <d-button
          theme="primary"
          outline
          class="ml-2"
          @click.prevent="saveFilters">
          Search
        </d-button>
        <d-button
          v-if="filters.search !== ''"
          theme="danger"
          outline
          class="ml-2"
          @click.prevent="resetFilters">
          Reset
        </d-button>
      </d-col>
    </d-row>

    <table class="table table-striped table-bordered table-hover mt-5">
      <thead>
        <tr>
          <sortable-table-heading field="name" view="airports" :column="orderColumn" :direction="orderDirection">Name</sortable-table-heading>
          <sortable-table-heading field="country_name" view="airports" :column="orderColumn" :direction="orderDirection">Country</sortable-table-heading>
          <sortable-table-heading field="icao" view="airports" :column="orderColumn" :direction="orderDirection">ICAO</sortable-table-heading>
          <sortable-table-heading field="iata" view="airports" :column="orderColumn" :direction="orderDirection">IATA</sortable-table-heading>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody v-if="!loadError">
        <tr v-if="!allDataLoaded">
          <td
            colspan="8"
            class="text-center">
            Loading airports&hellip;
          </td>
        </tr>
        <tr v-if="allDataLoaded && airports.length === 0">
            <td
              colspan="8"
              class="text-center">
              There are no airports to display&hellip;
            </td>
          </tr>
        <tr
          v-for="(airport, index) of airports"
          :key="'airport-' + index">
          <td class="align-middle">{{ airport.name }}</td>
          <td class="align-middle" style="width: 280px;">{{ airport.country_name }}</td>
          <td class="align-middle" style="width: 120px;">{{ airport.icao }}</td>
          <td class="align-middle" style="width: 120px;">{{ airport.iata }}</td>
          <td class="align-middle" style="width: 70px;">
            <d-button
              theme="primary"
              @click.native="$router.push('/dashboard/airports/' + airport.id)"
              class="mr-2"
              title="Edit airport">
              <i class="material-icons">search</i>
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      An error occurred during data loading. <a href="javascript:window.location.reload();" class="alert-link">Reload the page</a> to try again.
    </d-alert>

    <pagination :meta-data="paginationMetaData" />
  </div>
</template>

<script>
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import SortableTableHeading from './../components/common/SortableTableHeading.vue';

export default {
  name: 'airports',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    'sortable-table-heading': SortableTableHeading
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data () {
    return {
      loaded: false,
      airports: null,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    removeAirport (airportID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/airports/delete/',
        id: airportID,
        successTitle: 'Airport removed',
        successText: 'The selected airport has been removed',
        confirmTitle: 'Do you really want to remove this airport?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
          this.$bus.$emit('calendar-reload-airports');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">

</style>
